exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.display-content[data-v-19180b17] {\n  display: contents !important;\n}\n", ""]);

// exports
